import React from 'react'

export const Header = () => {
    return (
    <header>
        <h1> New Albums & Singles</h1>
    </header>
    )
} 